import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import 'react-toastify/dist/ReactToastify.css';
import "aos/dist/aos.css";
import reportWebVitals from "./reportWebVitals";
import { NotificationsProvider } from "./Context/notificationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <NotificationsProvider>
  <App />
</NotificationsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
